import React, {Component} from 'react';
import './SurveyForm.scss';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
} from 'reactstrap';
import SurveyGridForm from './SurveyGridForm';
import SaveButton from './SaveButton';
import InstructionModal from './InstructionModal';

class SurveyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: props.form.groups.reduce((result, cur) => {
        result[cur.id] = true;
        return result;
      }, {}),
      instructionModalOpen: false,
    }

    this.isGroupError = this.isGroupError.bind(this);
    this.instructionModalToggle = this.instructionModalToggle.bind(this);
  }

  instructionModalToggle() {
    this.setState({
      instructionModalOpen: !this.state.instructionModalOpen
    });
  }

  toggle(element) {
    let id = element.id;
    this.setState({
      collapse: {
        ...this.state.collapse,
        [id]: !this.state.collapse[id]
      }
    });
  }

  isGroupError(group) {
    return group.rows.reduce((result, row) => {
      return result || row.cols.reduce((result, col) => {
        return result || (this.props.formErrors[col.valueId] && this.props.formErrors[col.valueId].length > 0)
      }, false)
    }, false);
  }

  renderGroup(group) {
    group.ref = React.createRef();
    return (
      <div key={group.id} ref={group.ref} className="field-group">
        <div color="primary" className={"field-group-button " + (this.isGroupError(group) && "text-danger")} onClick={() => {this.toggle(group)}} style={{ marginBottom: '1rem' }}>{group.name}</div>
        <Collapse
          className="field-group-collapse"
          isOpen={typeof this.state.collapse[group.id] == "undefined" ? false : this.state.collapse[group.id]}>

          {group.remark && <Row>
            <Col>{group.remark}</Col>
          </Row>}
          <SurveyGridForm
            group={group}
            setFormValue={this.props.setFormValue}
            saveValues={this.props.saveValues}
            formValues={this.props.formValues}
            formErrors={this.props.formErrors}
            editable={this.props.form.editAble} />
        </Collapse>
      </div>
    )
  }

  renderForm() {
    return (
      <Card className="SurveyForm">
        {this.props.form.instruction && <CardHeader>
          <Row>
            <Col xs={12}>
              <Button onClick={this.instructionModalToggle}>Instructions</Button>
            </Col>
          </Row>
        </CardHeader>}
        <CardBody>
          <div className="animated fadeIn">
            {this.props.form.groups.map((group)=> this.renderGroup(group))}
          </div>
        </CardBody>
        {this.props.form.instruction && <InstructionModal
          isOpen={this.state.instructionModalOpen}
          toggle={this.instructionModalToggle}
          title={"Instructions"}
          body={this.props.form.instruction}
          size={"lg"}/>
        }
      </Card>
    );
  }

  render() {
    return this.renderForm();
  }
}

export default SurveyForm;



// WEBPACK FOOTER //
// ./src/components/SurveyView/SurveyForm/SurveyForm.js